<template>
    <div class="question-object-phonetic-consonant">
        <div class="question-object-phonemic-value">
            <span class="question-object-phonemic-value__label">SESBİRİM</span>
            <span class="question-object-phonemic-value__text">/ {{ phonemicValue }} /</span>
        </div>
        <div class="question-object-phonetic-value">
            <span class="question-object-phonetic-value__label">SESBİRİMCİK</span>
            <span class="question-object-phonetic-value__text">[ {{ phoneticValue }} ]</span>
        </div>
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        props: {
            phonemicValue: { type: String, default: 'h' },
            phoneticValue: { type: String, default: 'x'}
        }
    };
</script>

<style scoped src="@/css/components/question-object-phonetic-consonant.css"></style>